
import { defineComponent, inject } from 'vue';
import { InjectionKeys } from '@/constants';
import MaterialIcon from '@/components/MaterialIcon.vue';
import Label from '@/components/form-controls/base/Label.vue';
import { useVModel } from 'vue-composable';
import TextInputStyleProvider from '@/components/style-providers/TextInputStyleProvider.vue';

export default defineComponent({
  name: 'CheckboxWithUnit',
  emits: ['update:modelValue'],
  components: {
    MaterialIcon,
    Label,
    TextInputStyleProvider
  },
  props: {
    label: {
      type: String,
      required: true
    },
    explanationText: {
      type: String,
      required: true
    },
    modelValue: {
      required: true
    }
  },
  setup(props) {
    const setDirty = inject(InjectionKeys.SetFormDirty);
    const checkboxValue = useVModel(props, 'modelValue');

    const toggleCheckbox = () => {
      checkboxValue.value = !checkboxValue.value;
      setDirty;
    };

    return {
      setDirty,
      checkboxValue,
      toggleCheckbox
    };
  }
});
